import React, {Component} from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link
} from "react-router-dom";
import ReactGA from 'react-ga';
import ParallaxScrollWrapper from "./components/parallaxScrollWrapper";
import Header from "./components/header";
import StickyCountdown from "./components/stickyCountdown";
import Seo from "./utils/seo";
import Footer from "./components/footer";
import ParallaxUpdater from "./components/parallaxUpdater";
import Home from "./pages/home";
import Contact from "./pages/contact";
import ThankYou from "./pages/thankYou";
import Event from "./pages/event";
import Story from "./pages/story";
import Sponsors from "./pages/sponsors";
import Mission from "./pages/mission";
import Forms from "./pages/forms";
import Register from "./pages/register";
import PeakPurpose from "./pages/peak-purpose";
import ReferralProgram from "./pages/referral-program";
import Camping from "./pages/camping";
import Lodging from "./pages/lodging";
import StayWithUs from "./pages/stay-with-us";
import FaqPage from "./pages/faq";
import SkillsClinicsPage from "./pages/skills-clinics";
import Clinics from "./pages/clinics";
import Merch from "./pages/merch";
import GetReady from "./pages/get-ready";
import {Colors} from "./utils/variables";

//ReactGA.initialize('');

export class Layout extends Component {
  constructor(props) {
      super(props);
      this.state = ({

			})
  }
  componentDidMount = () => {
    const el = document.querySelector('.app-scroll-container');
    if (el) el.scrollTop = 0;
    else window.scrollTo(0, 0);
  }

  componentDidUpdate = () => {
    const el = document.querySelector('.app-scroll-container');
    if (el) el.scrollTop = 0;
    else window.scrollTo(0, 0);
  }
  
  render() {
    return(
      <div>
        <ParallaxUpdater />
        { this.props.children }
        <Footer />
      </div>
    )
  }
}

export default class App extends Component {
  constructor() {
      super();
			this.state = {}
  }


  render() {
   return (
     <>
       <ParallaxScrollWrapper>
         <Router>
           <div>
             <Header />
             <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/contact" element={<Layout><Contact /></Layout>} />
              <Route path="/thankyou" element={<Layout><ThankYou /></Layout>} />
              <Route path="/event" element={<Layout><Event /></Layout>} />
              <Route path="/get-ready" element={<Layout><GetReady /></Layout>} />
              <Route path="/forms" element={<Layout><Forms /></Layout>} />
              <Route path="/story" element={<Layout><Story /></Layout>} />
              <Route path="/mission" element={<Layout><Mission /></Layout>} />
              <Route path="/sponsors" element={<Layout><Sponsors /></Layout>} />
              <Route path="/register" element={<Layout><Register /></Layout>} />
              <Route path="/peak-purpose" element={<Layout><PeakPurpose /></Layout>} />
              <Route path="/referral-program" element={<Layout><ReferralProgram /></Layout>} />
              <Route path="/camping" element={<Layout><Camping /></Layout>} />
              <Route path="/lodging" element={<Layout><Lodging /></Layout>} />
              <Route path="/stay-with-us" element={<Layout><StayWithUs /></Layout>} />
              <Route path="/faq" element={<Layout><FaqPage /></Layout>} />
              <Route path="/skills-clinics" element={<Layout><SkillsClinicsPage /></Layout>} />
              <Route path="/clinics" element={<Layout><Clinics /></Layout>} />
              <Route path="/merch" element={<Layout><Merch /></Layout>} />
             </Routes>
           </div>
         </Router>
       </ParallaxScrollWrapper>
       {/* Temporary: Summer 2027 — full restore checklist: src/restoreWhenLive.js */}
       <StickyCountdown
         title="Summer 2027"
         time="Jun 1, 2027 00:00:00"
         titleColor={Colors.white}
         textColor={Colors.white}
         backgroundColor={Colors.primary}
       />
     </>

	 );
  }
}
